import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Typography from '@mui/material/Typography';
import { Grid, List, ListItem, Box, Divider } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ImageGallery from 'react-image-gallery';
import Commande from './Commande';
import { CommandeProvider } from "../contexts/CommandeContext";
import ServiceProduit from '../services/ServiceProduit';
import "react-image-gallery/styles/css/image-gallery.css";
import "../css/image-gallery.css";

export default function FicheProduit() {

	let { prestationKey, produitKey, finalize } = useParams();

	// Chargement des données du produit
	let produit = ServiceProduit.getProduit(prestationKey, produitKey);

	// Si le produit existe bien
	if (produit) {

		// Creation du tableau pour l'affichage du carousel à partir de la liste des photos du produit
		let imagesProduit = produit.photos.map((photo) => ({
			original: process.env.REACT_APP_PATH_IMAGES + '/' + produit.key + '/' + photo.fichier,
			originalAlt: photo.description,
		}));

		return (

			<Grid item py={2} px={{ xs: 0, sm: 2, md: 4, lg: 20 }}>
				<Typography component="h1" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 36, md: 36, lg: 54 }, fontWeight: 600 }}>
					{produit.contenu.titre}
				</Typography>
				<Divider sx={{ backgroundColor: '#004afe', mb: 4, mt: 2, height: 3, width: 130 }} />

				<Grid container>

					<Grid item xs={12} sm={12} md={6} py={2}>

						<Box component="div" sx={{ color: '#555555', borderRadius: 0, pr: 2 }} >

							<Typography component="p" sx={{ mb: 4 }}>
								{produit.contenu.intro}
							</Typography>

							<Box component="div">
								<Typography component="p" variant="highlight3" sx={{ align: 'left' }}>
									Details de la prestation
								</Typography>
								
								<List sx={{ mb: 4 }}>
									{
										// Boucle sur la liste des détails
										produit.contenu.descriptionListe.map(function(element, index) {
											return (
												<ListItem key={index} >
													<CheckCircleOutlineIcon sx={{ mr: 2 }} />{element}
												</ListItem>
											)
										})
									}
								</List>
								
								{(produit.contenu.descriptionListeNonInclusLabel !== undefined && produit.contenu.descriptionListeNonInclusLabel !== '') &&
									<>
										<Typography component="p" sx={{ align: 'left' }}>
											{produit.contenu.descriptionListeNonInclusLabel}
										</Typography>
										<List sx={{ mb: 4 }}>
											{
												// Boucle sur la liste des détails
												produit.contenu.descriptionListeNonInclus.map(function(element, index) {
													return (
														<ListItem key={index} >
															<HighlightOffIcon sx={{ mr: 2 }} />{element}
														</ListItem>
													)
												})
											}
										</List>
									</>
								}

								{(produit.contenu.descriptionConseil !== undefined && produit.contenu.descriptionConseil !== '') &&
									<>
										<Typography component="p" variant="highlight3" sx={{ align: 'left', mb: 1 }}>
											Notre conseil
										</Typography>

										<Typography component="p" variant="p" sx={{ align: 'left' }}>
											{produit.contenu.descriptionConseil}
										</Typography>
									</>
								}

								{(produit.contenu.descriptionNotes !== undefined && produit.contenu.descriptionNotes !== '') &&
									<Typography component="p" variant="p" sx={{ align: 'left', fontStyle: 'italic' }} mt={3}>
										{produit.contenu.descriptionNotes}
									</Typography>
								}
							</Box>

						</Box>

					</Grid>

					<Grid item xs={12} sm={12} md={6} py={2}>
						<ImageGallery
							items={imagesProduit}
							showThumbnails={false}
							showFullscreenButton={false}
							showPlayButton={false}
							autoPlay={true}
							showNav={true}
							showBullets={true}
							additionalClass="image-gallery-container"
						/>
					</Grid>

					<Grid item>
						<Typography component="h2" sx={{ color: '#004afe', fontSize: { xs: 26, sm: 36, md: 36, lg: 46 }, fontWeight: 400 }}>
							Réserver mon intervention
						</Typography>
						<Divider sx={{ backgroundColor: '#004afe', mb: 4, mt: 2, height: 3, width: 130 }} />
					</Grid>

					<Grid item>
						<CommandeProvider>
							<Commande finalize={finalize} />
						</CommandeProvider>
					</Grid>

					<Helmet>
						<title>{produit.seo.title}</title>
						<meta name="description" content={produit.seo.metaDescription} />
					</Helmet>

				</Grid>
			</Grid>
		);

	} // Fin si le produit existe bien

}